module.exports = __webpack_public_path__ + "img/account.99725102.svg";